import React, { useEffect, useRef, useState } from 'react'
import { LuTriangleAlert, LuX } from 'react-icons/lu'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { toast } from 'react-toastify';
import nameIcon from "../../images/forms/name.svg";
import emailIcon from "../../images/forms/email.svg";
import phoneIcon from "../../images/forms/phone.svg";
import yearIcon from "../../images/forms/year.svg";
import graduationIcon from "../../images/forms/graduation.svg";
import collegeIcon from "../../images/forms/college.svg";
import universityIcon from "../../images/forms/university.svg";
import locationIcon from "../../images/forms/location.svg";
import departmentIcon from "../../images/forms/department.svg";
import interestIcon from "../../images/forms/interested.svg";
import streamIcon from "../../images/forms/experience.svg";
import axios from 'axios';
import API from '../../../utils/API';
import ack from "../../images/forms/ack.webp";
import LoadLottie from '../loadLottie';
import Tick from "../../../json/tick-mark.json";
import Error from "../../../json/error.json";

export default function SurgeCollegeForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [year, setYear] = useState("");

    const [primaryContact, setPrimaryContact] = useState("");
    const [website, setWebsite] = useState("");
    const [totalCount, setTotalCount] = useState("");
    const [location, setLocation] = useState("");

    const [institutionType, setInstitutionType] = useState("");
    const [role, setRole] = useState("");
    const [stream, setStream] = useState([]);

    const [acknowledge, setAcknowledge] = useState(false);

    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [numberError, setNumberError] = useState("");
    const [yearError, setYearError] = useState("");

    const [primaryContactError, setPrimaryContactError] = useState("");
    const [websiteError, setWebsiteError] = useState("");
    const [totalCountError, setTotalCountError] = useState("");
    const [locationError, setLocationError] = useState("");

    const [institutionTypeError, setInstitutionTypeError] = useState("");
    const [roleError, setRoleError] = useState("");
    const [streamError, setStreamError] = useState("")

    const [countryCode, setCountryCode] = useState({});

    const [isStep1, setIsStep1] = useState(false);
    const [isStep2, setIsStep2] = useState(false);
    const [isStep3, setIsStep3] = useState(false);

    const [isClicked, setIsClicked] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isPaymentFailed, setIsPaymentFailed] = useState(false);
    const [timeLeft, setTimeLeft] = useState(30);
    const timerRef = useRef(null);

    const [scriptLoaded, setScriptLoaded] = useState(false);

    const invalidCharsRegex = /^[\s\u200B-\u200D\uFEFF]+$/;
    const websiteRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

    const handleStep1 = async () => {
        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const phoneWithoutPlus = number.startsWith(`+${countryCode?.dialCode}`)
                ? number.slice(countryCode?.dialCode?.length + 1)
                : number;

            // --- Regex Helpers ---
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/i;

            // --- Name Validation ---
            if (!name.trim()) return setNameError("Please fill in this");
            if (invalidCharsRegex.test(name)) return setNameError("Invalid special characters");

            // --- Email Validation ---
            if (!email) return setEmailError("Please fill in this");
            if (invalidCharsRegex.test(email)) return setEmailError("Invalid special characters");
            if (!emailRegex.test(email)) return setEmailError("Hmm... that email doesn't look right");

            // --- Phone Validation ---
            let isValid = false;
            try {
                const parsedPhone = phoneUtil.parse(number, countryCode?.iso2);
                isValid = phoneUtil.isValidNumber(parsedPhone);
            } catch {
                isValid = false;
            }
            if (!isValid || !phoneWithoutPlus) {
                return setNumberError("Hmm... that number doesn't look right");
            }

            // --- Linkedin Validation ---
            if (!year.trim()) return setYearError("Please fill in this");
            if (invalidCharsRegex.test(year)) return setYearError("Invalid special characters");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_SUBMIT, {
                officialEmail: email,
                institutionName: name,
                phone: number,
                yearEstablished: year,
            });

            if (data?.statusCode === 200) {
                setIsStep1(true)
            }
            setIsStep1(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep2 = async () => {
        try {

            // --- Graduation year Validation ---
            if (!primaryContact.trim()) return setPrimaryContactError("Please fill in this");
            if (invalidCharsRegex.test(primaryContact)) return setPrimaryContactError("Invalid special characters");

            // --- College name Validation ---
            const value = website.trim();

            if (!value) {
                setWebsiteError("Please fill in this");
                return
            } else if (!websiteRegex.test(value)) {
                setWebsiteError("Invalid website URL");
                return
            } else {                
                setWebsiteError("");    
            }

            // --- University name Validation ---
            if (!totalCount.trim()) return setTotalCountError("Please fill in this");
            if (invalidCharsRegex.test(totalCount)) return setTotalCountError("Invalid special characters");

            // --- Linkedin Validation ---
            if (!location.trim()) return setLocationError("Please fill in this");
            if (invalidCharsRegex.test(location)) return setLocationError("Invalid special characters");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_SUBMIT, {
                officialEmail: email,
                primaryContactName: primaryContact,
                websiteUrl: website,
                totalStudents: totalCount,
                location: location
            });

            if (data?.statusCode === 200) {
                setIsStep2(true)
            }
            setIsStep2(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep3 = async () => {
        try {

            // --- InstitutionType Validation ---
            if (!institutionType.trim()) return setInstitutionTypeError("Please Select atleast one option...");

            // --- Interested track Validation ---
            if (!role.trim()) return setRoleError("Please Select atleast one option...");

            // --- stream Validation ---
            if (stream?.length === 0) return setStreamError("Please Select atleast one option...");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_SUBMIT, {
                officialEmail: email,
                institutionType: institutionType,
                designation: role,
                streamsOffered: stream.join(", "),
            });

            if (data?.statusCode === 200) {
                setIsStep3(true)
            }
            setIsStep3(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep4 = async () => {
        try {

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_SUBMIT, {
                officialEmail: email,
                ack: acknowledge
            });

            if (data?.statusCode === 200) {
                if (acknowledge) {
                    handleSubmit()
                } else {
                    setIsSuccess(true)
                }
            }
            if (acknowledge) {
                handleSubmit()
            } else {
                setIsSuccess(true)
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };


    const handleSubmitPayment = async () => {
        try {

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_UPDATE_PAYMENT, {
                officialEmail: email,
            });

            if (data?.statusCode === 200) {
                setIsSuccess(true)
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const loadScript = async (src) => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            document.body.appendChild(script);
        });
    }

    const handleSubmit = async () => {
        try {
            setIsClicked(true)
            const { data } = await axios.post(
                API.PAYMENT,
                {
                    userCount: 1, subscriptionType: "monthly", pageType: "surgeStudent", packageType: "", redirectLink: "",
                },
            );
            if (data === "nodomain") {
                alert("Domain url wrong");
                window.location.href = "/404";
            }
            else if (data?.statusCode === 200) {
                razorPayment(data?.data);
            }
        } catch (err) {
            var statusCode = err?.response?.status;
            console.log(statusCode);
        }
    };

    const razorPayment = async (purchaseData) => {
        if (!scriptLoaded) {
            await loadScript('https://checkout.razorpay.com/v1/checkout.js'); // Load the Razorpay script dynamically
            setScriptLoaded(true);
        }

        const options = {
            key: API.KEY,
            description: "Surge Students",
            order_id: purchaseData?.id,
            handler: async (response) => {
                handleSubmitPayment()
                const res = await axios.post(API.PAYMENT_SUCCESS, {
                    ...response,
                }, {
                    headers: { "x-axios-request": "true" }
                });
                if (res.data.success) {
                    // window.location.href = res.data.redirectUrl;
                }
            },
            notes: {
                purchaseId: purchaseData?.id
            },
            prefill: {
                // email: email,
                // contact: phoneNumber,
                // 'method': 'card' //netbanking|card|upi|wallet
            },
            modal: {
                ondismiss: async () => {
                    await axios.post(API.PAYMENT_CLOSED, { id: purchaseData?.id });
                    setIsPaymentFailed(true)
                    setIsSuccess(true)
                    setIsClicked(false)
                },
            },
            theme: {
                color: "#560095"
            },
            config: {
                display: {
                    hide: [
                        { method: 'paylater' },
                        { method: 'emi' },
                        { method: 'cardless_emi' },
                        // { method: 'upi' },
                    ],
                }
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    };

    const tracks = [
        "Vice Chancellor",
        "Principal",
        "Director",
        "Dean",
        "Head of Department (HOD)",
        "Training & Placement Head",
    ];

    const toggleStream = (value) => {
        setStream((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
        setStreamError("");
    };


    useEffect(() => {
        if (isSuccess) {
            // reset timer every time popup opens
            setTimeLeft(30);

            timerRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        if (isPaymentFailed) {
                            setIsSuccess(false);
                            setIsPaymentFailed(false);
                        } else {
                            window.location.href = "/surge-colleges"
                        }
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);

    return (
        <div className='p-[20px] md:p-[50px] h-screen flex flex-col gap-[30px]'>
            <div>
                <div className='flex justify-between gap-[14px]'>
                    <div>
                        <h1 className='text-[#080808] font-semibold text-[20px] md:text-[28px]'>Registration Form | Surge College</h1>
                        <h2 className='mt-[7px] text-[16px] md:text-[22px] font-normal'>Fill out the form below to reserve your spot.</h2>
                    </div>
                    <LuX className='text-[20px] md:text-[24px] mt-[5px]' onClick={() => { window.location.href = "/surge-colleges" }} />
                </div>
                <div className="grid gap-[10px] py-[10px] grid-cols-4 mt-[10px] md:mt-[20px]">
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF3B30] transition-all duration-500 ease-in-out ${isStep1 ? "w-full rounded-full" : "w-1/2 rounded-l-full"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF9500] transition-all duration-500 ease-in-out ${isStep2 ? "w-full rounded-full" : isStep1 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#34C759] transition-all duration-500 ease-in-out ${isStep3 ? "w-full rounded-full" : isStep2 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#00C7BE] transition-all duration-500 ease-in-out ${(isSuccess && !isPaymentFailed) ? "w-full rounded-full" : isStep3 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                </div>
            </div>
            <div className={`flex justify-start items-center w-full overflow-hidden h-full`}>
                {/* ---- Step 1 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={nameIcon} alt='nameIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Institution Name <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={name} placeholder='Enter your Institution name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setName(e.target.value); setNameError('') }} />
                        </div>
                        {nameError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{nameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={emailIcon} alt='emailIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Official Email ID <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='email' value={email} placeholder='Enter your official Email ID' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setEmail(e.target.value); setEmailError('') }} />
                        </div>
                        {emailError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{emailError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FFCC0026] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={phoneIcon} alt='phoneIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Mobile Number / Office Contact <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[6px] md:px-[11px] py-[8px]'>
                            <PhoneInput defaultCountry="in" value={number} onChange={(phone, country) => { setNumber(phone); setCountryCode(country?.country); setNumberError(''); }}
                                countrySelector={{
                                    showSearch: true,
                                    searchPlaceholder: "Search country...",
                                }}
                                className="max-h-[40px] sm:max-h-[60px] h-full w-full focus:outline-none cursor-pointer surge-form placeholder:text-[#000]" />
                        </div>
                        {numberError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{numberError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={yearIcon} alt='yearIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Year of Establishment  <span className='text-[#FF2D55]'>* </span> </div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='number' value={year} placeholder='Enter a year of establishment' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setYear(e.target.value); setYearError("") }} />
                        </div>
                        {yearError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{yearError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 2 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-1 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#00C7BE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={graduationIcon} alt='graduationIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Primary Contact (Name) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={primaryContact} placeholder='Enter the your primary contact' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setPrimaryContact(e.target.value); setPrimaryContactError('') }} />
                        </div>
                        {primaryContactError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{primaryContactError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#30B0C733] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={collegeIcon} alt='collegeIcon' className='w-[10px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Website URL <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={website} placeholder='Enter college Website URL' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setWebsite(e.target.value); setWebsiteError('') }} />
                        </div>
                        {websiteError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{websiteError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#32ADE633] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={universityIcon} alt='universityIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Total Students Count <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='number' value={totalCount} placeholder='Enter total students count' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setTotalCount(e.target.value); setTotalCountError('') }} />
                        </div>
                        {totalCountError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{totalCountError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#007AFF33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={locationIcon} alt='locationIcon' className='w-[7px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Location <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={location} placeholder='Enter your location' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setLocation(e.target.value); setLocationError('') }} />
                        </div>
                        {locationError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{locationError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 3 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep3 ? "opacity-0 -translate-x-[300%]" : isStep2 ? "opacity-1 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#AF52DE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={departmentIcon} alt='departmentIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Institution Type <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${institutionType === "University" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (institutionType === "University") { setInstitutionType(""); } else { setInstitutionType("University"); setInstitutionTypeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${institutionType === "University" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>University</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${institutionType === "Autonomous College" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (institutionType === "Autonomous College") { setInstitutionType(""); } else { setInstitutionType("Autonomous College"); setInstitutionTypeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${institutionType === "Autonomous College" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Autonomous College</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${institutionType === "Affiliated College" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (institutionType === "Affiliated College") { setInstitutionType(""); } else { setInstitutionType("Affiliated College"); setInstitutionTypeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${institutionType === "Affiliated College" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Affiliated College</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${institutionType === "Polytechnic / Diploma" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (institutionType === "Polytechnic / Diploma") { setInstitutionType(""); } else { setInstitutionType("Polytechnic / Diploma"); setInstitutionTypeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${institutionType === "Polytechnic / Diploma" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Polytechnic / Diploma</h3>
                            </div>
                        </div>
                        {institutionTypeError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{institutionTypeError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF2D5533] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={interestIcon} alt='interestIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Designation <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px] md:h-[150px] overflow-y-scroll'>
                            {tracks.map((track, index) => (
                                <div key={index} className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${role === track ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`}
                                    onClick={() => {
                                        if (role === track) {
                                            setRole("");
                                        } else {
                                            setRole(track);
                                            setRoleError("");
                                        }
                                    }}
                                >
                                    <div
                                        className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${role === track ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`} >
                                        <span className="font-bold">
                                            {String.fromCharCode(65 + index)}
                                        </span>
                                    </div>
                                    <h3 className="w-full text-start break-word text-[12px] sm:text-[18px]">
                                        {track}
                                    </h3>
                                </div>
                            ))}

                        </div>
                        {roleError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{roleError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#A2845E33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={streamIcon} alt='streamIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Streams Offered <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${stream.includes("Engineering") ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { toggleStream("Engineering") }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${stream.includes("Engineering") ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Engineering</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${stream.includes("Arts & Science") ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { toggleStream("Arts & Science"); }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${stream.includes("Arts & Science") ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Arts & Science</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${stream.includes("Management") ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { toggleStream("Management") }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${stream.includes("Management") ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Management</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${stream.includes("Polytechnic") ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { toggleStream("Polytechnic") }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${stream.includes("Polytechnic") ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Polytechnic</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${stream.includes("Others") ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { toggleStream("Others") }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${stream.includes("Others") ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>E</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Others</h3>
                            </div>
                        </div>
                        {streamError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{streamError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 4 ---- */}
                <div className={`w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll text-center ${isStep3 ? "opacity-1 -translate-x-[300%]" : isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <img src={ack} alt='ack' className='mx-auto size-[100px] md:size-[140px]' />
                    <p className='mt-[10px] md:mt-[20px] text-[#080808] font-medium text-[18px] md:text-[30px]'>Also Acknowledgement that:</p>
                    <p className='mt-[10px] md:mt-[20px] text-[#080808] font-medium text-[20px] md:text-[34px]'>Surge Students is a learning & mentorship program</p>
                    <p className='mt-[10px] md:mt-[20px] text-[#080808] font-bold text-[20px] md:text-[34px]'>No Job or Placement Guarantee</p>
                    <div className='flex gap-[7px] md:gap-[14px] items-center justify-center mt-[10px] md:mt-[20px] cursor-pointer' onClick={() => { setAcknowledge(!acknowledge) }}>
                        <div className={`${acknowledge ? "border-[2px] border-[#34C759]" : "border-[1px] border-[#646464]"} size-[16px] md:size-[24px] p-[2px] md:p-[4px] rounded-full transition-all duration-200`}>
                            {acknowledge && (
                                <div className='bg-[#34C759] size-full rounded-full'></div>
                            )}
                        </div>
                        <p className='text-[16px] md:text-[25px] font-medium'>Yes I agree</p>
                    </div>
                </div>
            </div>
            <div className='flex gap-[10px] md:gap-[20px] items-center justify-center flex-wrap'>
                <button disabled={!isStep1} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] border border-[#54545657] text-[#3C3C4399] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        if (isStep3) {
                            setIsStep3(false)
                        } else if (isStep2) {
                            setIsStep2(false)
                        } else if (isStep1) {
                            setIsStep1(false)
                        }
                    }}>Back</button>
                <button disabled={isClicked} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] bg-[#34C759] text-[#FFFFFF] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        if (!isStep1) {
                            handleStep1()
                        } else if (!isStep2) {
                            handleStep2()
                        } else if (!isStep3) {
                            handleStep3()
                        } else if (isStep3) {
                            handleStep4()
                        }
                    }}>Next</button>
            </div>
            {isSuccess && (
                <div className="bg-[#000]/[70%] fixed inset-0 z-[100] h-screen w-full flex justify-center items-center">
                    <div className='bg-[#FFF] w-11/12 md:w-1/2 max-h-[80vh] rounded-[14px] p-[20px] relative text-center'>
                        <LuX className='text-[16px] md:text-[22px] cursor-pointer absolute top-[20px] right-[20px]'
                            onClick={() => {
                                if (isPaymentFailed) {
                                    setIsPaymentFailed(false);
                                    setIsSuccess(false);
                                    setTimeLeft(30);
                                    if (timerRef.current) {
                                        clearInterval(timerRef.current);
                                        timerRef.current = null;
                                    }
                                } else {
                                    window.location.href = "/surge-colleges"
                                }
                            }} />
                        <div className='font-medium text-[16px] md:text-[22px]'>
                            <p className='text-[#414141] text-center'>Automatically closing in</p>
                            <div className='size-[40px] md:size-[50px] mx-auto mt-[4px] md:mt-[7px] rounded-full border-[2px] border-[#34C759] flex justify-center items-center text-[#34C759]'>{timeLeft}</div>
                        </div>
                        <div className='mt-[12px] md:mt-[24px]'>
                            <div className='size-[80px] md:size-[120px] mx-auto flex justify-center items-center'>
                                <LoadLottie animationData={isPaymentFailed ? Error : Tick} loop={true} />
                            </div>
                            <p className='text-[20px] md:text-[25px] mt-[4px] font-semibold text-[#000000]'>{isPaymentFailed ? "Payment Failed. Please try again." : "Congratulations your slot is booked successfully"}</p>
                            <p className='text-[16px] md:text-[22px] mt-[4px] font-medium text-[#828487]'>{isPaymentFailed ? "Your slot wasn’t booked. If money was deducted, it’ll be refunded shortly." : "We sent the details in registered email."}</p>
                        </div>
                        <button className={`mt-[12px] md:mt-[24px] w-full h-[45px] md:h-[72px] rounded-[12px] md:rounded-[18px] text-[16px] md:text-[25px] font-semibold ${isPaymentFailed ? "bg-[#FFDD09] text-[#000000]" : "bg-[#34C759] text-[#F3F3F3]"}`}
                            onClick={() => {
                                if (isPaymentFailed) {
                                    setIsPaymentFailed(false);
                                    setIsSuccess(false);
                                    setTimeLeft(30);
                                    if (timerRef.current) {
                                        clearInterval(timerRef.current);
                                        timerRef.current = null;
                                    }
                                } else {
                                    window.location.href = "/surge-colleges"
                                }
                            }}>{isPaymentFailed ? "Try Again " : "Back to Home"}</button>
                    </div>
                </div>
            )}
        </div>
    )
}
